import React, {Fragment} from 'react';
import PropTypes from 'prop-types';
import {withLocalization} from '@epic-core/localization';

const generateMessages = (statusData, getMessage) => {
    const {status, incidents} = statusData;

    if (status) {
        if (status.indicator === 'none') {
            // if everything is fine
            return (
                <Fragment>
                    <span>{getMessage('epic.games.status')}</span>
                    <span>{status.description}</span>
                </Fragment>
            );
        }

        if (incidents.length) {
            // if incidents has something, incidents should start playing here
            const moreIncidents = incidents.length > 1;
            let incident = incidents[0];
            if (moreIncidents) {
                const sortedArray = incidents.asMutable().sort((a, b) => {
                    // sort ele by updated_at, latest comes first
                    const tsA = new Date(a.updated_at).getTime();
                    const tsB = new Date(b.updated_at).getTime();
                    return tsB - tsA;
                });
                // pick the latest update
                incident = sortedArray[0];
            }

            return `${incident.name} (${incident.status})`;
        }

        // if incidents is empty, use status as fallback
        return (
            <Fragment>
                <span>{getMessage('epic.games.status')} </span>
                <span>{status.description}</span>
            </Fragment>
        );
    }

    return '';
};

const StatusBar = ({statusData, url, fetching, getMessage}) => {
    let statusClass = '';
    try {
        statusClass = statusData.status.indicator;
    } catch (ex) {
        // no-op
    }
    return (
        <a href={url} className={`epic-status-bar ${statusClass || ''}`}>
            <div className={`message-wrapper ${fetching ? 'loading' : ''}`}>
                {statusData ? generateMessages(statusData, getMessage) : null}
            </div>
        </a>
    );
};

StatusBar.propTypes = {
    getMessage: PropTypes.func,
    statusData: PropTypes.object,
    url: PropTypes.string,
    fetching: PropTypes.bool
};

export default withLocalization(StatusBar);
